import isEqual from "lodash/isEqual";
import { deviceStatusesSelector } from "redux-store/device-statuses/selectors";
import { devicesSelector } from "redux-store/devices/selectors";
import { networksSelector } from "redux-store/networks/selectors";
import { createSelector } from "reselect";

import { calcStats } from "./calc-stats";

let deviceStats = {};
function _calcDeviceStats(devices, deviceStatuses, networks) {
  const newStats = calcStats(devices, networks, deviceStatuses);

  if (!isEqual(deviceStats, newStats)) {
    deviceStats = newStats;
  }

  return deviceStats;
}

/*
 * Calculate device stats from the store state.
 */
const calcDeviceStatsSelector = createSelector(
  devicesSelector,
  deviceStatusesSelector,
  networksSelector,
  _calcDeviceStats,
);

function _getDevices(state, props) {
  return props.devices;
}

/*
 * Calculate device stats from component devices prop.
 */
const calcPropsDeviceStatsSelector = createSelector(
  _getDevices,
  deviceStatusesSelector,
  networksSelector,
  _calcDeviceStats,
);

export {
  _calcDeviceStats,
  calcDeviceStatsSelector,
  calcPropsDeviceStatsSelector,
};
